// extracted by mini-css-extract-plugin
export var closeButton = "_q2-2";
export var closeButtonIcon = "_q2-3";
export var lightboxContent = "_q2-1";
export var lightboxOverlay = "_q2-0";